import React from 'react';
import { Container, Grid, Paper, Button } from '@mui/material';
import { useHistory } from 'react-router-dom';

import Router from './routes';

import { Sidebar } from './components';

const Agency = () => {
  const history = useHistory();
  return (
    <Grid container spacing={2} mb={3} mt={2}>
      <Grid item md={12}>
        <Paper style={{ padding: '15px' }}>
          <Router />
        </Paper>
      </Grid>
    </Grid>
  );
};

export default Agency;
